export type AddressInfoData = {
  addressLine1: string
  addressLine2: string
  city: string
  state: string
  zipCode: string
  /** True when order address lookup populated these fields (kit registration autofill). */
  addressAutofillFromLookup?: boolean
}

export function createEmptyAddressInfo(): AddressInfoData {
  return {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
  }
}
